import React, { useState, useEffect } from "react";
import "../../../styles/Categories.css";
import BlankTrainingExercise from "./BlankTrainingExercise";
import { db } from "../../../firebase";
import { doc, onSnapshot } from "firebase/firestore";
import { useAuth } from "../../../contexts/AuthContext";
import { freeContent } from "../../../utils/freeContent";
import { useSubscriptionStatus } from "../../../hooks/useSubscriptionStatus";

const BlankTrainingCategories = ({ onBack }) => {
  const [selectedPattern, setSelectedPattern] = useState(null);
  const [completedCategories, setCompletedCategories] = useState({});
  const { currentUser } = useAuth();
  const { isActive } = useSubscriptionStatus();
  const [showVideoModal, setShowVideoModal] = useState(false);

  useEffect(() => {
    if (!currentUser) return;

    const userDocRef = doc(db, "users", currentUser.uid);

    const unsubscribe = onSnapshot(userDocRef, (docSnapshot) => {
      if (docSnapshot.exists()) {
        const data = docSnapshot.data();
        const blankTrainingData = data?.part5?.blankTraining || {};
        const newCompletedCategories = {};

        Object.keys(blankTrainingData).forEach((categoryId) => {
          if (blankTrainingData[categoryId]?.completed) {
            newCompletedCategories[categoryId] = true;
          }
        });

        setCompletedCategories(newCompletedCategories);
      }
    });

    return () => unsubscribe();
  }, [currentUser]);

  const categories = [
    { id: 18, title: "시제", subcategory: "tense-practice" },
    { id: 17, title: "관계사 관련", subcategory: "relative-practice" },
    { id: 23, title: "전치사", subcategory: "prepositions" },
    { id: 25, title: "꾸미거나 보충하는 요소들", subcategory: "modifiers" },
    { id: 24, title: "접속사/접속부사", subcategory: "conjunctives" },
    { id: 19, title: "수동태/능동태", subcategory: "voice" },
    { id: 20, title: "수일치", subcategory: "agreement" },
    { id: 21, title: "한정사/대명사", subcategory: "determiners" },
    { id: 22, title: "비교급/최상급", subcategory: "comparison" },
  ];

  if (selectedPattern) {
    return (
      <BlankTrainingExercise
        patternId={selectedPattern}
        onBack={() => setSelectedPattern(null)}
      />
    );
  }

  return (
    <div className="categories-container">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          marginBottom: "20px",
        }}
      >
        <button className="back-button" onClick={onBack}>
          ← 뒤로가기
        </button>

        <button
          className="back-button"
          style={{ backgroundColor: "#4a4a7a" }}
          onClick={() => setShowVideoModal(true)}
        >
          설명 동영상 보기
        </button>
      </div>
      <h2>빈칸 훈련</h2>
      <div className="training-description">
        <p>
          이 훈련은 한국어를 영어 어순으로 배치하여 원어민의 사고방식을 이해하는
          데 도움을 줍니다. 빈칸이 있는 문장에서 원어민이 실제로 어떤 단어를
          사용하는지 훈련함으로써, 자연스러운 영어 표현을 익힐 수 있습니다.
        </p>
        <p>
          각 카테고리별로 문법 요소를 나누어 체계적으로 학습할 수 있으며,
          원어민의 관점에서 영어를 이해하고 사용하는 능력을 기를 수 있습니다.
        </p>
      </div>
      <div className="category-grid">
        {categories.map((category) => {
          const freeSubcategories =
            freeContent.part5.subcategories["blank-training"] || [];
          const isFreeContent = freeSubcategories.includes(
            category.subcategory
          );

          return (
            <div
              key={category.id}
              className={`category-card ${
                completedCategories[category.id] ? "completed" : ""
              } ${!isActive && !isFreeContent ? "premium" : ""}`}
              onClick={() => setSelectedPattern(category.id)}
            >
              <div className="category-content">
                <h3>{category.title}</h3>
                {completedCategories[category.id] && (
                  <span className="completion-status">학습 완료!</span>
                )}
              </div>
              {!isActive && !isFreeContent && (
                <div className="lock-overlay">
                  <img src="/icons/lock.svg" alt="잠김" />
                </div>
              )}
            </div>
          );
        })}
      </div>
      {showVideoModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1100,
          }}
          onClick={() => setShowVideoModal(false)}
        >
          <div
            style={{
              background: "#222",
              borderRadius: "8px",
              padding: "20px",
              width: "90%",
              maxWidth: "800px",
              position: "relative",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                background: "none",
                border: "none",
                color: "white",
                fontSize: "24px",
                cursor: "pointer",
              }}
              onClick={() => setShowVideoModal(false)}
            >
              ×
            </button>
            <video
              src="/videos/blank-training-explanation.mp4"
              controls
              autoPlay
              style={{ width: "100%", marginTop: "20px" }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default BlankTrainingCategories;
